// Import the comprehensive top 1000 coins list from CoinGecko
import { TOP_1000_COINS_DATA } from './top1000CoinsData';

// Use local logos for all coins
export const TOP_1000_COINS = TOP_1000_COINS_DATA.map(coin => ({
  id: coin.id,
  symbol: coin.symbol,
  name: coin.name,
  image: `/coin-logos/${coin.id}.png`, // Use local logo
  marketCapRank: coin.marketCapRank
}))

export interface CoinData {
  rank: number;
  id: string;
  symbol: string;
  name: string;
  image: string;
  current_price: number;
  price_change_percentage_1h: number;
  price_change_percentage_24h: number;
  price_change_percentage_7d: number;
  market_cap: number;
  total_volume: number;
  circulating_supply: number;
  max_supply: number | null;
  sparkline_in_7d: {
    price: number[];
  };
}